import { Box, Typography, useTheme } from "@mui/material"
import { useEffect, useState } from "react"

const TextEstadoTicket = ({
    titulo,
    descripcion,
    abiertoCerrado,
    estado
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [info, setInfo] = useState({
        color: '#74767f',
        background: '#e7e7e9',
        texto: 'En Proceso'
    })

    useEffect(() => {
        if(abiertoCerrado){
            if(!estado){
                setInfo({
                    color: isDarkMode ? '#4ade80' : '#018155',
                    background: isDarkMode ? '#1a3a2a' : '#E6F8F2',
                    texto: 'Abierto'
                })
            }else{
                setInfo({
                    color: isDarkMode ? '#b0bec5' : '#74767f',
                    background: isDarkMode ? '#2d3a52' : '#e7e7e9',
                    texto: 'Cerrado'
                })
            }
        }else{
            switch (descripcion) {
                case 'ABIERTO':
                    setInfo({
                        color: isDarkMode ? '#4ade80' : '#018155',
                        background: isDarkMode ? '#1a3a2a' : '#E6F8F2',
                        texto: 'Abierto'
                    })
                    break;
                case 'CERRADO':
                    setInfo({
                        color: isDarkMode ? '#b0bec5' : '#74767f',
                        background: isDarkMode ? '#2d3a52' : '#e7e7e9',
                        texto: 'Cerrado'
                    })
                    break;
                case 'PORVENCER':
                    setInfo({
                        color: isDarkMode ? '#fbbf24' : '#be7200',
                        background: isDarkMode ? '#3a2e1a' : '#fff2d1',
                        texto: 'Por Vencer'
                    })
                    break;
                case 'VENCEHOY':
                    setInfo({
                        color: isDarkMode ? '#fbbf24' : '#be7200',
                        background: isDarkMode ? '#3a2e1a' : '#fff2d1',
                        texto: 'Vence Hoy'
                    })
                    break;
                case 'VENCIDO':
                    setInfo({
                        color: isDarkMode ? '#f87171' : '#9d0b0b',
                        background: isDarkMode ? '#3a1a1a' : '#fce7e7',
                        texto: 'Vencido'
                    })
                    break;
                default:
                    setInfo({
                        color: isDarkMode ? '#90caf9' : '#1565c0',
                        background: isDarkMode ? 'linear-gradient(135deg, #1e3a5c 0%, #2a4a6a 100%)' : 'linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%)',
                        texto: descripcion || '-'
                    })
                    break;
            }
        }
    }, [descripcion, abiertoCerrado, estado, isDarkMode])

    return (
        <Box 
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1,
                gap: 2
            }}
        >
            <Typography sx={{
                color: isDarkMode ? '#b0bec5' : '#2c3e50',
                fontWeight: 600,
                fontSize: 12,
                minWidth: 'fit-content',
                flexShrink: 0
            }}>
                {titulo}:
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 0,
                    py: 0,
                    borderRadius: '20px',
                    background: info?.background,
                    minWidth: '100px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 12,
                        color: info?.color,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                    component='div'
                >
                    <Box component="span" sx={{fontSize: 16}}>•</Box>
                    {info?.texto}
                </Typography>
            </Box>
        </Box>
    )
}

export default TextEstadoTicket